var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manager-dashboard-list"},[_c('Header'),_c('div',{staticClass:"main-content"},[_c('OrganizationAdminList',{attrs:{"organizationUuid":_vm.me.organizationUuid}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }